import React, { useState, useEffect } from 'react';
import 'video.js/dist/video-js.css';
import MobilePlayerCard from '../items/MobilePlayerCard';
import sessionStore from './../../stores/session';
import LinearProgress from '@mui/material/LinearProgress';
import playerStore from './../../stores/player';
import performanceStore from '../../stores/performance';
import { Views } from './../../enums/enums';
import navigationStore from '../.././stores/navigation';

function MobilePlayer() {

  const sessionToken = sessionStore((state) => state.sessionToken);
  const safeArea = navigationStore((state) => state.safeArea);
  const currentView = navigationStore((state) => state.currentView);
  const countdown = performanceStore((state) => state.countdown);
  const nextPerformance = performanceStore((state) => state.nextPerformance);
  const currentPerformance = performanceStore((state) => state.currentPerformance);
  const getStreamUrl = playerStore((state) => state.getStreamUrl);
  const setPaddingBottom = navigationStore((state) => state.setPaddingBottom);
  const setPlayIsOn = performanceStore((state) => state.setPlayIsOn);
  const playQueue = performanceStore((state) => state.playQueue);
  const setCurrentPosition = performanceStore((state) => state.setCurrentPosition);
  const currentVersion = playerStore((state) => state.currentVersion);
  const currentTrack = playerStore((state) => state.currentTrack);
  const goToView = navigationStore((state) => state.goToView);
  const currentTime = playerStore((state) => state.currentTime);
  const setIsPlaying = playerStore((state) => state.setIsPlaying);
  const isMobilePlayerVisible = navigationStore((state) => state.isMobilePlayerVisible);
  const setMobilePlayerVisible = navigationStore((state) => state.setMobilePlayerVisible);

  const currentProgress = () => {
    if (currentTrack && currentTrack.length) {
      return (currentTime / currentTrack.length.split(':').reduce((acc, time) => (60 * acc) + +time)) * 100;
    } else {
      return 0;
    }
  };

  const lengthToMinutes = (length) => {
    const splitted = length.split(":");
    if (splitted.length == 3) {
      return splitted[1] + ":" + splitted[2];
    }
  };

  const renderPlayer = () => {
    if (currentView != Views.Blank) {
      if (nextPerformance && countdown > 0) {
        return <div>
          <MobilePlayerCard
            isPerformance={false}
            image={nextPerformance.track.url_cover_image ? nextPerformance.track.url_cover_image : ""}
            primary={nextPerformance.track.artist}
            secondary={countdown + "s - " + nextPerformance.profile.name + " - " + nextPerformance.track.title}
            kcode={nextPerformance.track.kcode}
            pitch={nextPerformance.pitch}
            length={lengthToMinutes(nextPerformance.track.length)}
            currentProgress={0}
            onClick={() => {
              goToView(Views.Blank);
              setMobilePlayerVisible(true);
              window.dispatchEvent(new Event('refitbuttons'));
              window.dispatchEvent(new Event('resize'));
              setPaddingBottom("muvika-performances-list", -35);
            }}
          />
          <LinearProgress sx={{
            bottom: safeArea ? "calc("+safeArea.bottom+"px + 3.9rem) !important" : "3.9rem !important", paddingLeft: safeArea ? safeArea.left + "px" : 0,
            paddingRight: safeArea ? safeArea.right + "px" : 0
          }} className="muvika-mobile-player-progress" variant="determinate" value={currentProgress()} />
        </div>;
      } else if (currentTrack && currentPerformance) {
        return <div><MobilePlayerCard
          isPerformance={true}
          image={currentPerformance.track.url_cover_image ? currentPerformance.track.url_cover_image : ""}
          primary={currentPerformance.track.artist}
          secondary={currentPerformance.profile.name + " - " + currentPerformance.track.title}
          currentProgress={currentProgress()}
          kcode={currentPerformance.track.kcode}
          pitch={currentPerformance.pitch}
          length={lengthToMinutes(currentPerformance.track.length)}
          onClick={() => {
            goToView(Views.Blank);
            setMobilePlayerVisible(true);
            window.dispatchEvent(new Event('refitbuttons'));
            window.dispatchEvent(new Event('resize'));
            setPaddingBottom("muvika-performances-list", -35);
          }}
        />
          <LinearProgress sx={{
            bottom: safeArea ? "calc("+safeArea.bottom+"px + 3.9rem) !important" : "3.9rem !important", paddingLeft: safeArea ? safeArea.left + "px" : 0,
            paddingRight: safeArea ? safeArea.right + "px" : 0
          }} className="muvika-mobile-player-progress" variant="determinate" value={currentProgress()} />
        </div>;
      } else if (playQueue && currentPerformance) {
        return <div>
          <MobilePlayerCard
            isPerformance={true}
            image={currentPerformance.track.url_cover_image ? currentPerformance.track.url_cover_image : ""}
            primary={currentPerformance.track.artist}
            secondary={currentPerformance.profile.name + " - " + currentPerformance.track.title}
            kcode={currentPerformance.track.kcode}
            length={lengthToMinutes(currentPerformance.track.length)}
            pitch={currentPerformance.pitch}
            currentProgress={currentProgress()}
            onClick={() => {
              goToView(Views.Blank);
              setCurrentPosition(currentPerformance.position, currentPerformance);
              getStreamUrl(sessionToken, currentPerformance, currentPerformance.track, currentPerformance.pitch, currentVersion, currentTime, false);
              setMobilePlayerVisible(true);
              window.dispatchEvent(new Event('refitbuttons'));
              window.dispatchEvent(new Event('resize'));
              setPaddingBottom("muvika-performances-list", -35);
            }}
          />
          <LinearProgress sx={{
            bottom: safeArea ? "calc("+safeArea.bottom+"px + 3.9rem) !important" : "3.9rem !important", paddingLeft: safeArea ? safeArea.left + "px" : 0,
            paddingRight: safeArea ? safeArea.right + "px" : 0
          }} className="muvika-mobile-player-progress" variant="determinate" value={currentProgress()} />
        </div>;
      }else{
        return <div>
          <MobilePlayerCard
            isEmpty={true}
            onClick={() => {
              goToView(Views.Blank);
              setMobilePlayerVisible(true);
              window.dispatchEvent(new Event('refitbuttons'));
              window.dispatchEvent(new Event('resize'));
              setPaddingBottom("muvika-performances-list", -35);
            }}
          />
          <LinearProgress sx={{
            bottom: safeArea ? "calc("+safeArea.bottom+"px + 3.9rem) !important" : "3.9rem !important", paddingLeft: safeArea ? safeArea.left + "px" : 0,
            paddingRight: safeArea ? safeArea.right + "px" : 0
          }} className="muvika-mobile-player-progress" variant="determinate" value={0} />
        </div>
      }
    }
  };

  return (
    <div id="muvika-mobile-player">
      {renderPlayer()}
    </div>
  );
}

export default MobilePlayer;